import EVENT_TYPE from './EventType';

const EVENT_COLOR = {
  [EVENT_TYPE.meeting]: '#3478B9',
  [EVENT_TYPE.outing]: '#FCA01F',
  [EVENT_TYPE.companyVisit]: '#91B508',
};

export default EVENT_COLOR;
